// eslint-disable-next-line import/no-cycle
import { get, put, post, postForm, putForm, del } from 'utils/methods';

export function getTemplateApi(data) {
    return get(`${process.env.REACT_APP_REST}templates`, data);
}

export function addTemplateApi(data) {
    return postForm(`${process.env.REACT_APP_REST}commands/template`, data);
}

export function editTemplateApi(data) {
    return putForm(`${process.env.REACT_APP_REST}commands/template`, data);
}

export function toggleTemplateStatusApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/template/status`, data, headers);
}

export function attachPackagesToTemplateApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/package/template`, data, headers);
}

export function detachPackagesToTemplateApi(data, headers) {
    return del(`${process.env.REACT_APP_REST}commands/package/template`, data, headers);
}

export function getPackagesFromTemplateApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}packages`, data, headers);
}

export function getDesignTemplateApi(data) {
    return get(`${process.env.REACT_APP_REST}design-templates`, data);
}

export function editDesignTemplateApi(data, headers) {
    return putForm(`${process.env.REACT_APP_REST}commands/design-template`, data, headers);
}

export function updateTranslateDesignTemplateApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/design-template/translate`, data, headers);
}

export function statusDesignTemplateApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/design-template/status`, data, headers);
}
